import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { checkPermList, classNames as cn } from 'helpers'
import st from './ActionMenu.module.scss'
import { ReactComponent as MoreIcon } from './more-2-line.svg'
import { Link } from 'react-router-dom'
import ToggleCheckbox from '../ToggleCheckbox/ToggleCheckbox'
import { ReactComponent as ArrowIcon } from 'components/UI/icons/arrow-down-s-line.svg'

export const checkActionPermission = (perm) => {
  if (perm) {
    if (Array.isArray(perm)) {
      return !!perm.some((p) => checkPermList(p))
    } else {
      return !!checkPermList(perm)
    }
  } else {
    return true
  }
}

const ActionMenu = (props) => {
  const [open, setOpen] = useState(false)
  const refButton = useRef(null)
  const isArrowIcon = props.iconType === 'arrow'

  const clickClack = (action, e, items, line) => {
    setOpen(false)
    props.action(action, e, items, line)
  }

  useEffect(() => {
    if (open)
      document.body.addEventListener(
        'click',
        ({ target }) => {
          if (!refButton.current.contains(target)) setOpen(false)
        },
        { once: true },
      )
  }, [open])

  const renderAction = (action, index) => {
    const key = index
    if (action.title) {
      return (
        <span key={key} className={st.title}>
          <p className={st.title__name}>{action.title}</p>
        </span>
      )
    } else if (action.line === true) {
      return <span key={key} className={st.title__line}></span>
    } else if (action.checkbox) {
      return (
        <div key={key} className={st.title}>
          <div className={st.title__name}>
            <ToggleCheckbox
              key={`checkbox-${key}`}
              label={action.checkbox.label}
              checked={action.checkbox.value}
              onChange={action.checkbox.onChange}
            />
          </div>
        </div>
      )
    } else {
      return checkActionPermission(action.permission) ? (
        action.link ? (
          <Link key={key} to={action.link.to} target={action.link.target}>
            {action.name}
          </Link>
        ) : (
          <div
            className={st.actionItem}
            key={key}
            onClick={(e) => clickClack(action.action, e, props.items, action)}
          >
            {action.name}
          </div>
        )
      ) : null
    }
  }

  return (
    <div className={`${st.actionMenu} ${props.className || ''}`}>
      <div
        className={`${st.button} ${open ? st.buttonActive : ''} ${isArrowIcon ? st.buttonArrowIcon : ''}`}
        onClick={() => setOpen(!open)}
        ref={refButton}
      >
        {isArrowIcon ? (
          <ArrowIcon />
        ) : (
          <MoreIcon
            className={`${st.moreIcon} ${open ? st.moreIconActive : ''}`}
          />
        )}
      </div>
      <div
        className={cn({
          [st.modal]: true,
          [st.modalRight]: props.right,
          [st.modalLeft]: !props.right,
          [st.modalArrowType]: isArrowIcon && open,
          [st.modalOpen]: open,
          [st.modalClose]: !open,
        })}
      >
        <div className={`${st.menu} ${isArrowIcon ? st.arrowTypeMenu : ''}`}>
          {props.menu.map(renderAction)}
        </div>
      </div>
    </div>
  )
}

ActionMenu.propTypes = {
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      // name: PropTypes.string,
      // permission: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      // action: PropTypes.func,
      // link: PropTypes.shape({
      //   to: PropTypes.string.isRequired,
      //   target: PropTypes.string
      // }),
      // title: PropTypes.string,
      // checkbox: PropTypes.shape({
      //   label: PropTypes.string,
      //   value: PropTypes.bool.isRequired,
      //   onChange: PropTypes.func.isRequired
      // })
    }),
  ).isRequired,
  action: PropTypes.func,
}

export default ActionMenu
